import API_BASE_URL from '../config';

// Debug logging
console.log('🔧 API UTILITY DEBUG 🔧');
console.log('API_BASE_URL from config:', API_BASE_URL);
console.log('Login URL will be:', `${API_BASE_URL}/api/login`);

export const api = {
  // Auth endpoints
  login: `${API_BASE_URL}/api/login`,
  register: `${API_BASE_URL}/api/register`,
  
  // Check-in endpoints
  checkin: `${API_BASE_URL}/api/checkin`,
  checkins: `${API_BASE_URL}/api/checkins`,
  checkinToday: `${API_BASE_URL}/api/checkin/today`,
  
  // Goals endpoints
  goals: `${API_BASE_URL}/api/goals`,
  goalProgress: (goalId) => `${API_BASE_URL}/api/goals/${goalId}/progress`,
  
  // AI endpoints
  aiAnalysis: `${API_BASE_URL}/api/ai/analysis`,
  aiEnhancedAnalysis: `${API_BASE_URL}/api/ai/enhanced-analysis`,
  aiDailyRecommendations: `${API_BASE_URL}/api/ai/daily-recommendations`,
  aiPatterns: `${API_BASE_URL}/api/ai/patterns`,
  aiQuestion: `${API_BASE_URL}/api/ai/question`,
  
  // Weight goal endpoints
  weightGoal: `${API_BASE_URL}/api/weight-goal`,
  
  // Friends endpoints
  friends: `${API_BASE_URL}/api/friends`,
  friendsAdd: `${API_BASE_URL}/api/friends/add`,
  usersSearch: (query) => `${API_BASE_URL}/api/users/search?query=${encodeURIComponent(query)}`,
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Helper function for authenticated fetch requests
export const authenticatedFetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultOptions = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers
    },
    ...options
  };
  
  return fetch(url, defaultOptions);
};